import checkDeviceType from './checkDeviceType';
import { checkDeviceWidth } from './checkDeviceWidth';

function handleMouseenter(e) {
  e.target.classList.add('is-active');
  const dropdown = e.target.querySelectorAll('.header--sub-nav');
  dropdown[0].classList.add('is-active');
}

function handleMouseleave(e) {
  e.target.classList.remove('is-active');
  const dropdown = e.target.querySelectorAll('.header--sub-nav');
  dropdown[0].classList.remove('is-active');
}

const parseMobileNav = () => {
  // build out mobile nav
  const mobileNavMainLinks = document.querySelectorAll('.js-main-nav-target .main-menu-item, .js-main-nav-target .header--nav-forward, .js-main-nav-target .secondary-menu-item, #nm-search-toggle');
  // loop through mobile nav elements
  Array.prototype.forEach.call(mobileNavMainLinks, (mobileNavLink, index) => {
    // if menu cta, override mobile tap functionality, force click
    mobileNavLink.addEventListener('touchstart', function (e) {
      this.click();
      e.preventDefault();
    });
  });
};

// a little cheap and dirty (repeating code), but gets the job done (for now)
const removeParsedMobileNavListeners = () => {
  const mobileNavMainLinks = document.querySelectorAll('.js-main-nav-target .main-menu-item, .js-main-nav-target .header--nav-forward, .js-main-nav-target .secondary-menu-item, #nm-search-toggle');
  // loop through mobile nav elements
  Array.prototype.forEach.call(mobileNavMainLinks, (mobileNavLink, index) => {
    // remove any mobile tap listeners
    mobileNavLink.removeEventListener('touchstart', function (e) {
      this.click();
      e.preventDefault();
    });
  });
};

// Appending listeners with a throttled resize function to add or remove JS hover functionality depending on touch device or screen width.
// Basically, if the site is in mobile view with the hamburger menu, there will be no JS hover states.
let navTimeout = null;
const appendHoverStates = () => {
  if (navTimeout) {
    clearTimeout(navTimeout);
  }

  navTimeout = setTimeout(() => {
    navTimeout = null;
    const type = checkDeviceType();
    const widthCheck = checkDeviceWidth();
    const navItems = document.querySelectorAll('.js-main-nav-target');
    // If user is on desktop
    if (type !== 'touchscreen' && widthCheck === 'desktop') {
      for (let i = 0; i < navItems.length; i++) {
        navItems[i].addEventListener('mouseenter', handleMouseenter);
        navItems[i].addEventListener('mouseleave', handleMouseleave);
      }
    } else if (type !== 'touchscreen' && widthCheck === 'mobile') { // If on a desktop device with a mobile screenwidth
      for (let i = 0; i < navItems.length; i++) {
        navItems[i].removeEventListener('mouseenter', handleMouseenter);
        navItems[i].removeEventListener('mouseleave', handleMouseleave);
      }
    }
    // Else user is on an actual mobile device, and there's no need to add or remove any event listeners.
  }, 600);
};

window.addEventListener('resize', appendHoverStates);

appendHoverStates();
removeParsedMobileNavListeners(); // remove any straggler event listeners // TODO: do some checks to see if this is necessary
checkDeviceType() === 'touchscreen' && parseMobileNav(); // enable mobileNav
